import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

export default function LandingSignupCTA({ onRegister }) {
  return (
    <section className="border-t border-slate-200 bg-white py-20 sm:py-24">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[1.2fr_0.8fr] lg:gap-20">
        <div>
          <p className="mb-6 inline-flex items-center gap-2.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-violet-700">
            <span aria-hidden="true" className="h-1.5 w-1.5 shrink-0 bg-violet-600" />
            Automate your next release
          </p>
          <h2 className="mb-6 max-w-xl text-4xl font-semibold leading-tight tracking-tight text-slate-950 sm:text-5xl">
            Stop wasting time on manual testing
          </h2>
          <p className="mb-8 max-w-lg text-lg leading-8 text-slate-500">
            Sign up today and bring test automation into your release workflow
          </p>
          <Button onClick={onRegister} size="lg" className="rounded-full bg-violet-700 px-7 py-6 text-sm font-semibold text-white shadow-none hover:bg-violet-800">
            Start Your Free Trial
            <ArrowRight className="ml-3 h-4 w-4" />
          </Button>
        </div>
        <aside className="flex flex-col justify-center border-t border-slate-200 pt-10 lg:border-l lg:border-t-0 lg:pl-12 lg:pt-0" aria-label="The experience behind Lexa">
          <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.18em] text-violet-700">Built by QA professionals</p>
          <h3 className="text-3xl font-semibold leading-tight tracking-tight text-slate-950">20 years in QA.<br />Each.</h3>
          <p className="mt-5 max-w-sm text-base leading-8 text-slate-500">Two QA professionals bringing manual testing and automation experience into one platform.</p>
          <div className="mt-6 flex flex-wrap gap-2 text-xs font-medium text-slate-600">
            <span className="rounded-full border border-slate-200 px-3 py-2">Manual testing</span>
            <span className="rounded-full border border-slate-200 px-3 py-2">Test automation</span>
          </div>
        </aside>
      </div>
    </section>
  );
}
